import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  styled,
  TextField,
  Button,
  Paper,
  InputAdornment,
  IconButton,
  Box,
  Link,
  Typography,
} from "@mui/material";
import Send from "../../assets/images/Send.svg";
import GreenLibrary from "../../assets/images/GreenLibrary.svg";
import Rename from "../../assets/images/Rename.svg";
import Delete from "../../assets/images/Delete.svg";
import CallLog from "../../assets/images/CallLog.svg";
import MicIcon from "@mui/icons-material/Mic";
import {
  KeyboardDoubleArrowDown,
  KeyboardDoubleArrowUp,
} from "@mui/icons-material";
import PromptDialog from "../PromptDialog/PromptDialog";
import LikeDialog from "../LikeDialog/LikeDialog";
import UnlikeDialog from "../UnlikeDialog/UnlikeDialog";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import Loader from "../Loader";
import "./ChatFlow.scss";
import SnackbarComponent from "../Snackbar/Snackbar";
import { useLocation, useNavigate } from "react-router-dom";
import ChatsBox from "../ChatContent/ChatContent";
import { Edit } from "@mui/icons-material";
import {
  AppBar,
  Toolbar,
  MenuItem,
  Menu,
  Snackbar,
  Alert,
} from "@mui/material";
import RenameDialog from "../RenameDialog/RenameDialog";
import DeleteDialog from "../DeleteDialog/DeleteDialog";
import { deleteUserSession } from "../../redux/slice/delete-user-session";
import CallLogDialog from "../CallLogDialog/CallLogDialog";
import { CALL_LOG_DIALOG_TEST_DATA } from "../../sampledata/CallLogDialogTestData";
import {
  duplicatesRemoval,
  getUserSessions,
} from "../../redux/slice/get-user-sessions";
import {
  inputUpdate,
  messageUpdate,
  resetMessages,
  disableFormContol,
  productsUpdate,
  keyMessageUpdate,
  newChatStateUpdate,
  showSnackbar,
  setActiveChatToolId,
} from "../../redux/slice/snackbar";
import {
  clearStreamData,
  newchatfetchStreamData,
  newChatSession,
} from "../../redux/slice/new-stream-thunk";
import {
  clearStreamingData,
  fetchStreamData,
  postChatStream,
} from "../../redux/slice/stream-thunk";
import {
  convertToMessageFormat,
  getCurrentDateTime,
  normalizeFollowupOptions,
} from "../MessageConversionFormat";
import MicOffOutlinedIcon from "@mui/icons-material/MicOffOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import * as SpeechSDK from "microsoft-cognitiveservices-speech-sdk";
import { extractCallDetails } from "../../redux/slice/callLogSlice";
import { CircularProgress } from "@mui/material";
import {
  TOOL_REGISTRY,
  getToolSynapse360Disclaimer,
} from "../Tools/toolRegistry";
import ChatToolsPlus from "../Tools/ChatToolsPlus";
import ActiveToolPill from "../Tools/ActiveToolPill";

import { useDisplayIdentity } from "../../hooks/useDisplayIdentity";
import { UserNameSkeleton } from "../UserIdentitySkeleton/UserIdentitySkeleton";
import {
  clearKbStreamData,
  createKnowledgeBotSessionId,
  kbFetchStreamData,
  kbPostChatStream,
} from "../../redux/slice/knowledge-bot-stream";
import {
  getIncomingEmailFromToken,
  getOutgoingEmailFromToken,
} from "../../utils/common";
import { markPrompted } from "../../utils/sessionActivity";

const ColorButton = styled(Button)(() => ({
  color: "black",
  backgroundColor: "#6D94A7",
  minWidth: "40px",
  height: "40px",
  padding: "0px",
  "&.Mui-disabled": {
    backgroundColor: "#E5E5E5",
    color: "black",
    border: "1px solid #E5E5E5",
  },
  "&:hover": {
    backgroundColor: "#396D87",
  },
}));

function ChatFlow(props) {
  const {
    handleInputValue,
    drawerOpen,
    chatscroll,
    setChatScroll,
    sessionId,
    handleChats,
  } = props;

  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const queryParams = new URLSearchParams(location.search);
  const authUser = useSelector((state) => state.auth.user);
  const outgoingEmail = getOutgoingEmailFromToken();
  const incomingEmail = getIncomingEmailFromToken();
  const userEmail = outgoingEmail;
  const token = "__cookie__";
  const role = authUser?.business_function || "";

  const isRBD = (role ?? "").trim().toUpperCase() === "RBD";
  const isLeadership = (role ?? "").trim().toUpperCase() === "LEADERSHIP";

  const isSalesRep = (role ?? "").trim().toUpperCase() === "SALESREP";
  // const client = queryParams.get("client");
  const client = "UT";

  const {
    firstName,
    fullName: displayFullName,
    isLoading: displayIdentityLoading,
  } = useDisplayIdentity();

  const source = queryParams.get("source");

  const [dialogOpen, setDialogOpen] = useState(false);
  const [likeDialogOpen, setLikeDialogOpen] = useState(false);
  const [unLikeDialogOpen, setUnLikeDialogOpen] = useState(false);
  const [userSessionId, setUserSessionId] = useState("");
  const [chatId, setChatId] = useState("");
  const [callLogOpen, setCallLogOpen] = useState(false);
  const [logCallLoading, setLogCallLoading] = useState(false);
  const messagesEndRef = useRef(null);
  const messagesEndRefChild = useRef(null);

  const { isLoading, userChats } = useSelector((state) => state.userChats);
  const lastScrollY = useRef(0);
  const [hasScrollbar, setHasScrollbar] = useState(false);
  const activeToolId = useSelector((state) => state.snackbar.activeChatToolId);

  const activeTool = TOOL_REGISTRY.find((t) => t.id === activeToolId) || null;
  const isKnowledgeBotMode = activeToolId === "knowledge_bot";
  const toolSynapse360Disclaimer = getToolSynapse360Disclaimer(activeToolId);
  const kbPartitionEmail = incomingEmail || userEmail;

  const chatEndpoint =
    activeToolId === "external_sources" ? "chat_external" : "chat";

  const handleSelectTool = (toolId) => {
    const next = activeToolId === toolId ? null : toolId;

    if (next === "knowledge_bot" || activeToolId === "knowledge_bot") {
      dispatch(clearKbStreamData(false));
    }
    if (activeToolId === "knowledge_bot" && next !== "knowledge_bot") {
      dispatch(clearStreamData(false));
      dispatch(clearStreamingData(false));
    }

    dispatch(setActiveChatToolId(next));
  };

  const clearActiveTool = () => {
    if (activeToolId === "knowledge_bot") {
      dispatch(clearKbStreamData(false));
    }
    dispatch(setActiveChatToolId(null));
  };

  const checkone = useSelector((state) => state?.userSessions?.userSessions);
  const messages = useSelector((state) => state.snackbar.messages);
  const input = useSelector((state) => state.snackbar.input);

  const [streamData, setStreamData] = useState([]);

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const openMenu = Boolean(anchorEl);

  const [renameDialogOpen, setRenameDialogOpen] = useState(false);
  const [renameVal, setRenameval] = useState();
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [selectedCallData, setSelectedCallData] = useState(null);
  const chatUpdate = useSelector((state) => state.newChat.data);

  const streams = useSelector((state) => state.stream.items);
  const newChatStreams = useSelector((state) => state.newChatStream.data);
  const kbStreams = useSelector((state) => state.knowledgeBotStream.data);
  const kbSessionId = useSelector((state) => state.knowledgeBotStream.sessionId);

  const newSessionId = useSelector((state) => state.newChatStream.sessionId);

  const contStreamEndCheck = useSelector((state) => state.stream.streamEnd);
  const streamEndCheck = useSelector(
    (state) => state.newChatStream.streamingEnded,
  );
  const kbStreamEndCheck = useSelector(
    (state) => state.knowledgeBotStream.streamingEnded,
  );

  const newChatFinal = useSelector((state) => state.newChatStream.finalEvent);
  const contFinalEvent = useSelector((state) => state.stream.finalEvent);
  const kbFinalEvent = useSelector((state) => state.knowledgeBotStream.finalEvent);

  // ✅ HITL: clarification events (added in Step 1)
  const newChatClarification = useSelector(
    (state) => state.newChatStream.clarificationEvent,
  );
  const contClarification = useSelector(
    (state) => state.stream.clarificationEvent,
  );

  const { minRows, maxRows, filtered, newChatClicked } = useSelector(
    (state) => state.snackbar,
  );

  const tokengen = useSelector((state) => state.accessToken.token);
  const speechConfigAzure = useSelector(
    (state) => state.speechConfig.speechConfig,
  );

  const inputRef = useRef(input);
  const lastKbHistoryRefreshKey = useRef("");
  const [isListening, setIsListening] = useState(false);

  const [activeSessionId, setActiveSessionId] = useState(sessionId || "");

  // ✅ HITL state: when backend asks clarification, next user message is treated as "resume input"
  const [hitlPending, setHitlPending] = useState(null);
  // hitlPending shape example:
  // { event:"clarification", question, needed_fields, session_id, chat_id, thread_id }

  // keep in sync when parent prop changes (user clicks a session)
  useEffect(() => {
    if (sessionId) setActiveSessionId(sessionId);
  }, [sessionId]);

  // keep in sync when a NEW session is created via /session thunk
  useEffect(() => {
    if (newSessionId) setActiveSessionId(newSessionId);
  }, [newSessionId]);

  const tokenSet = source ? tokengen : token;

  const refreshSessionHistory = useCallback(async () => {
    const userSessionPayload = {
      userEmail,
      token: tokenSet,
      client,
      minRows: 0,
      maxRows,
    };
    try {
      await dispatch(getUserSessions(userSessionPayload)).unwrap();
      const dupAction = await dispatch(duplicatesRemoval());
      if (dupAction?.error) {
        console.error("duplicatesRemoval failed:", dupAction.error);
      }
    } catch (err) {
      console.error("Failed to refresh session history:", err);
    }
  }, [dispatch, userEmail, tokenSet, client, maxRows]);

  useEffect(() => {
    inputRef.current = input;
  }, [input]);

  useEffect(() => {
    if (!isKnowledgeBotMode || !kbStreamEndCheck || !kbFinalEvent?.chat_id) {
      return;
    }

    const refreshKey = `${kbFinalEvent.session_id}:${kbFinalEvent.chat_id}`;
    if (lastKbHistoryRefreshKey.current === refreshKey) {
      return;
    }
    lastKbHistoryRefreshKey.current = refreshKey;
    refreshSessionHistory();
  }, [
    isKnowledgeBotMode,
    kbStreamEndCheck,
    kbFinalEvent,
    refreshSessionHistory,
  ]);

  let getSessionName;
  if (filtered?.length > 0) {
    getSessionName = filtered?.find(
      (value) => value?.user_session_id === sessionId,
    );
  } else {
    getSessionName = checkone?.find(
      (value) => value?.user_session_id === sessionId,
    );
  }

  const supportedLanguages = ["en-US"];
  let recognizerRef = useRef(null);

  const startAzureRecognition = async () => {
    try {
      setIsListening(true);

      const speechConfig = SpeechSDK.SpeechConfig.fromSubscription(
        speechConfigAzure.speech_key,
        speechConfigAzure.speech_region,
      );

      speechConfig.setProperty(
        SpeechSDK.PropertyId.SpeechServiceConnection_InitialSilenceTimeoutMs,
        "50000",
      );

      const autoDetectLangConfig =
        SpeechSDK.AutoDetectSourceLanguageConfig.fromLanguages(
          supportedLanguages,
        );
      const audioConfig = SpeechSDK.AudioConfig.fromDefaultMicrophoneInput();

      const recognizer = SpeechSDK.SpeechRecognizer.FromConfig(
        speechConfig,
        autoDetectLangConfig,
        audioConfig,
      );

      recognizerRef.current = recognizer;

      recognizer.recognized = (s, e) => {
        if (e.result.reason === SpeechSDK.ResultReason.RecognizedSpeech) {
          const updatedText = inputRef.current + " " + e.result.text;
          dispatch(inputUpdate(updatedText));
          inputRef.current = updatedText;
        }
      };

      recognizer.canceled = () => stopAzureRecognition();
      recognizer.sessionStopped = () => stopAzureRecognition();

      recognizer.startContinuousRecognitionAsync();
    } catch (error) {
      setIsListening(false);
    }
  };

  const stopAzureRecognition = () => {
    if (recognizerRef.current) {
      recognizerRef.current.stopContinuousRecognitionAsync(() => {
        recognizerRef.current.close();
        recognizerRef.current = null;
      });
    }
    setIsListening(false);
  };

  useEffect(() => {
    const checkScrollbar = () => {
      if (messagesEndRef.current) {
        const { scrollHeight, clientHeight } = messagesEndRef.current;
        setHasScrollbar(scrollHeight > clientHeight);
      }
    };

    checkScrollbar();
    window.addEventListener("resize", checkScrollbar);

    return () => {
      window.removeEventListener("resize", checkScrollbar);
    };
  }, [messages]);

  const handleClick = (event, item) => {
    setAnchorEl(event.currentTarget);
    setSelectedItem(item);
  };
  const handleClose = () => setAnchorEl(null);

  const handleRenameDialogClickOpen = () => {
    setRenameval(getSessionName.user_session_name);
    setRenameDialogOpen(true);
    setAnchorEl(null);
  };
  const handleDeleteDialogClickOpen = () => {
    setDeleteDialogOpen(true);
    setAnchorEl(null);
  };

  useEffect(() => {
    if (isKnowledgeBotMode && kbStreams) setStreamData(kbStreams);
  }, [kbStreams, isKnowledgeBotMode]);

  useEffect(() => {
    if (!isKnowledgeBotMode && newChatStreams) setStreamData(newChatStreams);
  }, [newChatStreams, isKnowledgeBotMode]);

  useEffect(() => {
    if (!isKnowledgeBotMode && streams) setStreamData(streams);
  }, [streams, isKnowledgeBotMode]);

  // ✅ Helper: append a bot message without wiping chat
  const appendBotMessage = useCallback(
    (text, extras = {}) => {
      const botMessage = {
        text,
        sender: "bot",
        chatId: extras.chatId || "",
        userSessionId:
          extras.userSessionId || activeSessionId || sessionId || "",
        feedback: "",
        time: getCurrentDateTime(),
        options: [],
        email: "",
        withoutMarkDown: "",

        // ✅ image support
        chartIntent: extras.chartIntent || false,
        imgPath: extras.imgPath || "",

        tableFound: "",
        blobName: "",
        agentType: extras.agentType || "",
        recommendations: extras.recommendations || null,

        // ✅ HITL entity disambiguation fields
        hitlType: extras.hitlType || null,
        hitlCase: extras.hitlCase || null,
        hitlStep: extras.hitlStep || null,
        sections: extras.sections || null,
        selectedType: extras.selectedType || null,
        proposed: extras.proposed || null,
        hcpOptions: extras.hcpOptions || null,
        hcoOptions: extras.hcoOptions || null,
      };

      if (messages && messages.length > 0) {
        dispatch(messageUpdate([botMessage]));
      }
    },
    [dispatch, messages, activeSessionId, sessionId],
  );

  // ✅ HITL: when clarification event arrives, show question as normal bot text and set pending
  useEffect(() => {
    const evt = newChatClarification || contClarification;
    if (!evt) return;

    // Avoid re-processing the same clarification
    if (
      hitlPending?.chat_id &&
      evt.chat_id === hitlPending.chat_id &&
      evt.hitl_step === hitlPending.hitl_step
    )
      return;

    // Clear streaming buffers so UI doesn't keep showing tokens while waiting
    dispatch(clearStreamData(false));
    dispatch(clearStreamingData(false));

    setHitlPending(evt);

    // Determine if this is an entity disambiguation event
    const isEntityDisambiguation = evt.type === "early_entity_disambiguation";
    const hitlStep = evt.hitl_step || 1;
    const hitlCase = evt.hitl_case || "";

    // Build recommendations for the ChatContent suggestions panel.
    //
    // For the NEW hitl cases (confirm, select, no_match) we do NOT populate
    // recommendations.  The frontend renders interactive cards directly from
    // hcpOptions / hcoOptions stored on the message — this prevents the
    // generic "Suggestions" fallback from rendering a duplicate list.
    //
    // Only LEGACY cases (B/C/D from sections) and generic HITL use recommendations.
    let recommendations = {};
    const isNewCase =
      hitlCase === "confirm" ||
      hitlCase === "select" ||
      hitlCase === "no_match";

    if (isEntityDisambiguation && !isNewCase) {
      const allOptions = {};
      if (evt.hcp_options && evt.hcp_options.length > 0) {
        allOptions.hcp = evt.hcp_options;
      }
      if (evt.hco_options && evt.hco_options.length > 0) {
        allOptions.hco = evt.hco_options;
      }
      // Legacy fallback: sections-based format
      if (!allOptions.hcp && !allOptions.hco && evt.sections) {
        (evt.sections || []).forEach((sec) => {
          const opts = sec.options || {};
          Object.keys(opts).forEach((etype) => {
            if (!allOptions[etype]) allOptions[etype] = [];
            allOptions[etype].push(...(opts[etype] || []));
          });
        });
      }
      recommendations = allOptions;
    } else if (!isEntityDisambiguation) {
      // Generic (non-entity) HITL — pass through backend recommendations
      recommendations = evt.recommendations || {};
    }

    // Add question as a bot message in normal chat flow
    appendBotMessage(evt.question || "I need a bit more information.", {
      chatId: evt.chat_id || "",
      userSessionId: evt.session_id || activeSessionId || sessionId || "",
      agentType: "hitl_clarification",
      recommendations: recommendations,
      // Pass entity-specific metadata for enhanced rendering
      hitlType: isEntityDisambiguation ? "entity_disambiguation" : "generic",
      hitlCase: hitlCase,
      hitlStep: hitlStep,
      sections: evt.sections || [],
      selectedType: evt.selected_type || null,
      // New fields for CONFIRM flow
      proposed: evt.proposed || null,
      hcpOptions: evt.hcp_options || [],
      hcoOptions: evt.hco_options || [],
    });

    // Optionally guide user if needed_fields contains target (non-entity HITL)
    if (
      !isEntityDisambiguation &&
      Array.isArray(evt.needed_fields) &&
      evt.needed_fields.includes("target")
    ) {
      appendBotMessage(
        "Please type the territory name (or multiple, comma-separated). Example: PHOENIX or PHOENIX, DALLAS",
        {
          chatId: evt.chat_id || "",
          userSessionId: evt.session_id || activeSessionId || sessionId || "",
          agentType: "hitl_hint",
        },
      );
    }
  }, [
    newChatClarification,
    contClarification,
    hitlPending,
    dispatch,
    appendBotMessage,
    activeSessionId,
    sessionId,
  ]);

  const handleFilteredForNewStream = (finalEvent) => {
    if (!finalEvent) return;

    const chartBase64 = finalEvent?.chart?.base64_image || "";
    const hasChart = !!chartBase64 || finalEvent?.chart?.chart_intent === true;

    const botMessage = {
      text: finalEvent.content || "",
      sender: "bot",
      chatId: finalEvent.chat_id || "",
      userSessionId: finalEvent.session_id || sessionId || "",
      feedback: "",
      time: getCurrentDateTime(),
      options: normalizeFollowupOptions({
        suggested_questions: finalEvent.suggested_questions,
      }),
      email: "",
      withoutMarkDown: "",
      chartIntent: hasChart,
      imgPath: chartBase64,
      tableFound: "",
      blobName: "",
      agentType: "",
      sources: finalEvent.sources || [],
      structured: finalEvent.data || null,
      chartMeta: finalEvent?.chart?.metadata || null,
    };

    dispatch(resetMessages());
    if (messages.length > 0) {
      dispatch(messageUpdate([...messages, botMessage]));
    } else {
      dispatch(messageUpdate([botMessage]));
    }
  };

  // ✅ When stream ends, only commit final if not waiting on HITL
  if (isKnowledgeBotMode && kbStreamEndCheck && !hitlPending) {
    handleFilteredForNewStream(kbFinalEvent);
    dispatch(clearKbStreamData(false));
  } else if (contStreamEndCheck && !hitlPending && !isKnowledgeBotMode) {
    handleFilteredForNewStream(contFinalEvent);
    dispatch(clearStreamingData(false));
  } else if (streamEndCheck && !hitlPending && !isKnowledgeBotMode) {
    handleFilteredForNewStream(newChatFinal);
    dispatch(clearStreamData(false));
  }

  // ✅ Build resume payload for HITL.
  // Handles new HITL cases: confirm, select, no_match
  // Also supports legacy cases (B/C/D) for backward compatibility.
  //
  // New HITL Cases from backend:
  //   confirm step 1 → "Did you mean X?" → Yes/No buttons
  //   select  step 1 → direct top-5+top-5 list (scores too close)
  //   select  step 2 → after user said "No" to confirm → top-5+top-5 list
  //   no_match step 1 → no candidates found → free-text entry
  //
  // Legacy Cases (backward compat):
  //   B step 1 → type selection (HCP / HCO)
  //   B step 2 → candidate selection from selected type
  //   C step 1 → low-confidence candidate selection
  //   D step 1 → no match free-text
  const buildResumeFromUserText = (evt, userText) => {
    const resume = { chat_id: evt.chat_id };
    const answer = (userText || "").trim();
    const answerLower = answer.toLowerCase();

    const isEntityDisambiguation = evt.type === "early_entity_disambiguation";
    const hitlStep = evt.hitl_step || 1;
    const hitlCase = (evt.hitl_case || "").toLowerCase();

    // Also check legacy sections-based case
    const sections = evt.sections || [];
    const sec = sections[0] || {};
    const legacyCase = (sec.case || "").toUpperCase();

    if (isEntityDisambiguation) {
      // ==== NEW: CONFIRM case — Yes/No response ====
      if (hitlCase === "confirm") {
        if (
          answerLower === "yes" ||
          answerLower === "y" ||
          answerLower === "1"
        ) {
          resume.confirmed = true;
          return resume;
        } else if (
          answerLower === "no" ||
          answerLower === "n" ||
          answerLower === "2"
        ) {
          resume.confirmed = false;
          return resume;
        }
        // Fallback: treat any other input as "no" (user wants something else)
        resume.confirmed = false;
        return resume;
      }

      // ==== NEW: SELECT case — pick from combined HCP+HCO list ====
      if (hitlCase === "select") {
        const hcpOpts = evt.hcp_options || [];
        const hcoOpts = evt.hco_options || [];
        const nHcp = hcpOpts.length;
        const nHco = hcoOpts.length;
        const total = nHcp + nHco;

        // Number selection: 1..N_hcp = HCP, N_hcp+1..total = HCO
        const numMatch = answer.match(/^(\d+)$/);
        if (numMatch) {
          const idx = parseInt(numMatch[1], 10);
          if (idx >= 1 && idx <= nHcp) {
            resume.entity_type = "hcp";
            resume.selected_name = hcpOpts[idx - 1].name;
            resume.selected_index = idx;
            resume.free_text = false;
            return resume;
          } else if (idx > nHcp && idx <= total) {
            const hcoIdx = idx - nHcp;
            resume.entity_type = "hco";
            resume.selected_name = hcoOpts[hcoIdx - 1].name;
            resume.selected_index = idx;
            resume.free_text = false;
            return resume;
          }
        }

        // "HCP 2" / "HCO 1" pattern
        const typeNumMatch = answer.match(/^(hcp|hco)\s+(\d+)$/i);
        if (typeNumMatch) {
          const etype = typeNumMatch[1].toLowerCase();
          const idx = parseInt(typeNumMatch[2], 10);
          const pool = etype === "hcp" ? hcpOpts : hcoOpts;
          if (idx >= 1 && idx <= pool.length) {
            resume.entity_type = etype;
            resume.selected_name = pool[idx - 1].name;
            resume.selected_index = idx;
            resume.free_text = false;
            return resume;
          }
        }

        // Free text: user typed a custom name
        // Use entity_type_signal from backend when available; fall back to
        // proposed type, visible pool inference, or "hcp" as last resort.
        const signal = evt.entity_type_signal || "";
        const hcpPool = evt.hcp_options || [];
        const hcoPool = evt.hco_options || [];
        const poolGuess =
          hcoPool.length > 0 && hcpPool.length === 0
            ? "hco"
            : hcpPool.length > 0 && hcoPool.length === 0
              ? "hcp"
              : "";
        resume.entity_type =
          signal === "hcp" || signal === "hco"
            ? signal
            : evt.selected_type ||
              (evt.proposed || {}).entity_type ||
              poolGuess ||
              "hcp";
        resume.selected_name = answer;
        resume.free_text = true;
        return resume;
      }

      // ==== NEW: NO_MATCH case — free text entry ====
      if (hitlCase === "no_match") {
        // Use entity_type_signal from backend; fall back to keyword detection
        const nmSignal = evt.entity_type_signal || "";
        let guessType;
        if (nmSignal === "hcp" || nmSignal === "hco") {
          guessType = nmSignal;
        } else if (
          /\b(hospital|center|centre|clinic|university|health|care|medicine|service|pulmonary|associates|specialist|institute|physician|medical|consultant|respiratory)\b/i.test(
            answer,
          )
        ) {
          guessType = "hco";
        } else if (/\b(dr\.?|doctor|hcp)\b/i.test(answer)) {
          guessType = "hcp";
        } else {
          guessType = "hcp";
        }
        resume.entity_type = guessType;
        resume.selected_name = answer;
        resume.free_text = true;
        return resume;
      }

      // ==== LEGACY: Case B, Step 1: Type selection (HCP or HCO) ====
      if (hitlStep === 1 && legacyCase === "B") {
        if (answerLower === "hcp" || answerLower === "1") {
          resume.selection = "HCP";
        } else if (answerLower === "hco" || answerLower === "2") {
          resume.selection = "HCO";
        } else if (/^(hcp|hco)\s+\d+$/i.test(answerLower)) {
          resume.selection = answer;
        } else {
          resume.selection = answer;
        }
        return resume;
      }

      // ==== LEGACY: Case C/D Step 1 OR Case B Step 2: Name selection ====
      const isCandidateSelection =
        (hitlStep === 1 && (legacyCase === "C" || legacyCase === "D")) ||
        hitlStep === 2;

      if (isCandidateSelection) {
        const selectedType = evt.selected_type || sec.entity_type || "hcp";
        const candidates = (sec.options || {})[selectedType] || [];

        const numMatch = answer.match(/^(\d+)$/);
        if (numMatch) {
          const idx = parseInt(numMatch[1], 10);
          if (idx >= 1 && idx <= candidates.length) {
            resume.entity_type = selectedType;
            resume.selected_name = candidates[idx - 1].name;
            resume.selected_index = idx;
            resume.free_text = false;
            return resume;
          }
        }

        const typeNumMatch = answer.match(/^(hcp|hco)\s+(\d+)$/i);
        if (typeNumMatch) {
          const etype = typeNumMatch[1].toLowerCase();
          const idx = parseInt(typeNumMatch[2], 10);
          const typeCands = (sec.options || {})[etype] || candidates;
          if (idx >= 1 && idx <= typeCands.length) {
            resume.entity_type = etype;
            resume.selected_name = typeCands[idx - 1].name;
            resume.selected_index = idx;
            resume.free_text = false;
            return resume;
          }
        }

        resume.entity_type = selectedType;
        resume.selected_name = answer;
        resume.free_text = true;
        return resume;
      }

      // ==== FALLBACK for unknown entity_disambiguation case ====
      const primaryType = sec.entity_type || "hcp";
      const fallbackCands = (sec.options || {})[primaryType] || [];
      if (fallbackCands.length > 0) {
        const numMatch = answer.match(/^(\d+)$/);
        if (numMatch) {
          const idx = parseInt(numMatch[1], 10);
          if (idx >= 1 && idx <= fallbackCands.length) {
            resume.entity_type = primaryType;
            resume.selected_name = fallbackCands[idx - 1].name;
            resume.selected_index = idx;
            resume.free_text = false;
            return resume;
          }
        }
        resume.entity_type = primaryType;
        resume.selected_name = answer;
        resume.free_text = true;
        return resume;
      }

      resume.selection = answer;
      return resume;
    }

    // Legacy / generic HITL: single needed_field
    if (Array.isArray(evt.needed_fields) && evt.needed_fields.length === 1) {
      const fieldKey = evt.needed_fields[0];
      resume[fieldKey] = answer;
      return resume;
    }

    // Safety fallback
    resume.answer = answer;
    return resume;
  };

  const startNewSessionAndSend = useCallback(
    async (promptText) => {
      if (!promptText?.trim()) return;

      // Flag that this browser session has fired a prompt. This path is used
      // by the "Explore" buttons on the performance page (and any other
      // prefillPrompt-driven flow), which bypass handleSend entirely — so
      // markPrompted() must be called here too, otherwise had_prompt on the
      // ui_session_end event will incorrectly stay false.
      markPrompted();

      dispatch(clearStreamData(false));
      dispatch(clearStreamingData(false));
      dispatch(clearKbStreamData(false));
      dispatch(resetMessages());
      dispatch(inputUpdate(""));

      if (isKnowledgeBotMode) {
        const newSid = createKnowledgeBotSessionId();
        setActiveSessionId(newSid);

        const userMsg = {
          text: promptText,
          sender: "user",
          chatId: "",
          userSessionId: newSid,
          feedback: "",
          time: getCurrentDateTime(),
          options: [],
          email: "",
          withoutMarkDown: "",
          chartIntent: "",
          imgPath: "",
          tableFound: "",
          blobName: "",
          agentType: "",
        };
        dispatch(messageUpdate([userMsg]));

        await dispatch(
          kbFetchStreamData({
            sessionId: newSid,
            message: promptText,
            username: kbPartitionEmail,
          }),
        ).unwrap();

        setChatScroll("down");
        return;
      }

      // clear any previous stream + UI

      // ✅ force new session creation (no dependency on messages.length)
      const newChatSessionPayload = { userEmail, token: tokenSet, client };
      const createAction = await dispatch(
        newChatSession(newChatSessionPayload),
      );
      const api1Data = createAction?.payload;

      if (!api1Data?.session_id) {
        console.error("Failed to create session", createAction);
        return;
      }

      const newSid = api1Data?.session_id;
      if (!newSid) return;

      setActiveSessionId(newSid);

      // add the user message into UI immediately
      const userMsg = {
        text: promptText,
        sender: "user",
        chatId: "",
        userSessionId: newSid,
        feedback: "",
        time: getCurrentDateTime(),
        options: [],
        email: "",
        withoutMarkDown: "",
        chartIntent: "",
        imgPath: "",
        tableFound: "",
        blobName: "",
        agentType: "",
      };
      dispatch(messageUpdate([userMsg]));

      const passParam = {
        sessionId: newSid,
        payload: {
          session_id: newSid,
          message: promptText,
          resume: null,
          client: "repassist",
          metadata: {},
          okta_userinfo: {
            email: outgoingEmail,
            preferred_username: incomingEmail,
            email_verified: true,
            name: displayFullName || firstName || "User",
          },
        },
        client,
      };

      await dispatch(
        newchatfetchStreamData({
          ...passParam,
          endpoint: chatEndpoint,
        }),
      ).unwrap();

      // refresh history list
      await dispatch(
        getUserSessions({
          userEmail,
          token: tokenSet,
          client,
          minRows: 0,
          maxRows,
        }),
      ).unwrap();

      const dupAction = await dispatch(duplicatesRemoval());
      if (dupAction?.error) {
        console.error("duplicatesRemoval failed:", dupAction.error);
      }

      setChatScroll("down");
    },
    [
      dispatch,
      userEmail,
      tokenSet,
      client,
      displayFullName,
      firstName,
      maxRows,
      setChatScroll,
      chatEndpoint,
      isKnowledgeBotMode,
    ],
  );

  const handleSend = async (inputText, displayText = inputText) => {
    let inputValue = inputText;

    if (inputValue.trim().length === 0) return;

    // Flag that this browser session has fired at least one prompt so the
    // ui_session_end beacon can report had_prompt=true. Cheap sessionStorage
    // write; safe to call on every send.
    markPrompted();

    // Always add user message into chat
    const nextUserMsg = {
      text: displayText,
      sender: "user",
      chatId: "",
      userSessionId: activeSessionId || sessionId || "",
      feedback: "",
      time: getCurrentDateTime(),
      options: [],
      email: "",
      withoutMarkDown: "",
      chartIntent: "",
      imgPath: "",
      tableFound: "",
      blobName: "",
      agentType: "",
    };

    dispatch(messageUpdate([nextUserMsg]));

    // ✅ HITL RESUME PATH (not supported in Knowledge Bot mode)
    if (hitlPending && !isKnowledgeBotMode) {
      const sid =
        hitlPending.session_id || activeSessionId || sessionId || newSessionId;

      const resume = buildResumeFromUserText(hitlPending, inputValue);

      // Clear pending before dispatch so future final can commit normally
      setHitlPending(null);

      // Clear stream buffers
      dispatch(clearStreamData(false));
      dispatch(clearStreamingData(false));

      const body = {
        session_id: sid,
        message: null,
        resume,
        client: "repassist",
        metadata: {},
        okta_userinfo: {
          email: outgoingEmail,
          preferred_username: incomingEmail,
          email_verified: true,
          name: displayFullName || firstName || "User",
        },
      };

      try {
        await dispatch(
          postChatStream({
            sessionId: sid,
            data: body,
            userEmail,
            token: tokenSet,
            client,
            endpoint: chatEndpoint,
          }),
        );
      } catch (err) {
        console.error("HITL resume error:", err);
      }

      dispatch(inputUpdate(""));
      return;
    }

    if (isKnowledgeBotMode) {
      dispatch(clearKbStreamData(false));

      const sid =
        activeSessionId || kbSessionId || createKnowledgeBotSessionId();

      if (!activeSessionId && !kbSessionId) {
        setActiveSessionId(sid);
      }

      try {
        if (
          messages.length === 0 ||
          messages[0]?.text ===
            "I have just finished my call with Dr. ADAM BOSAK - can you log my notes"
        ) {
          await dispatch(
            kbFetchStreamData({
              sessionId: sid,
              message: inputValue,
              username: kbPartitionEmail,
            }),
          ).unwrap();
        } else {
          await dispatch(
            kbPostChatStream({
              sessionId: sid,
              data: {
                session_id: sid,
                message: inputValue,
                username: kbPartitionEmail,
              },
            }),
          );
        }
      } catch (err) {
        console.error("Knowledge Bot error:", err);
      }

      dispatch(inputUpdate(""));
      setChatScroll("down");
      return;
    }

    // ---- Normal send path (your existing logic) ----

    if (
      (messages.length > 1 &&
        inputText ===
          "I have just finished my call with Dr. ADAM BOSAK - can you log my notes") ||
      inputText ===
        "I have just finished my call with Dr. ADAM BOSAK - can you log my notes"
    ) {
      setTimeout(() => {
        dispatch(
          messageUpdate([
            {
              text: "bottext",
              sender: "bot",
              chatId: "",
              userSessionId: "",
              feedback: "",
              time: getCurrentDateTime(),
              options: [],
              email: "",
              withoutMarkDown: "",
              chartIntent: "",
              imgPath: "",
              tableFound: "",
              blobName: "",
              agentType: "",
            },
          ]),
        );
      }, 1000);
    }

    // New chat / first message
    if (
      (messages.length === 0 &&
        inputText !==
          "I have just finished my call with Dr. ADAM BOSAK - can you log my notes") ||
      messages[0]?.text ===
        "I have just finished my call with Dr. ADAM BOSAK - can you log my notes"
    ) {
      try {
        const newChatSessionPayload = {
          userEmail: userEmail,
          token: tokenSet,
          client,
        };

        const userSessionPayload = {
          userEmail: userEmail,
          token: tokenSet,
          client,
          minRows: 0,
          maxRows,
        };

        const api1Data = await dispatch(
          newChatSession(newChatSessionPayload),
        ).unwrap();

        setActiveSessionId(api1Data.session_id);

        const passParam = {
          sessionId: api1Data.session_id,
          payload: {
            session_id: api1Data.session_id,
            message: inputValue,
            resume: null,
            client: "repassist",
            metadata: {},
            okta_userinfo: {
              email: outgoingEmail,
              preferred_username: incomingEmail,
              email_verified: true,
              name: displayFullName || firstName || "User",
            },
          },
          client,
        };

        await dispatch(
          newchatfetchStreamData({
            ...passParam,
            endpoint: chatEndpoint,
          }),
        ).unwrap();
        await dispatch(getUserSessions(userSessionPayload)).unwrap();
        const dupAction = await dispatch(duplicatesRemoval());
        if (dupAction?.error) {
          console.error("duplicatesRemoval failed:", dupAction.error);
        }
      } catch (err) {
        console.error("Error:", err);
      }
    }

    // Existing chat continuation
    if (
      messages.length > 1 &&
      inputText !==
        "I have just finished my call with Dr. ADAM BOSAK - can you log my notes" &&
      messages[0]?.text !==
        "I have just finished my call with Dr. ADAM BOSAK - can you log my notes"
    ) {
      const sid = activeSessionId || sessionId || newSessionId;

      const body = {
        session_id: sid,
        message: inputValue,
        resume: null,
        client: "repassist",
        metadata: {},
        okta_userinfo: {
          email: outgoingEmail,
          preferred_username: incomingEmail,
          email_verified: true,
          name: displayFullName || firstName || "User",
        },
      };

      const data = {
        sessionId: sid,
        data: body,
        userEmail,
        token: tokenSet,
        client,
        endpoint: chatEndpoint,
      };

      try {
        await dispatch(postChatStream({ ...data, data: body }));
      } catch (err) {
        console.error("Error:", err);
      }

      setChatScroll("down");
    }

    dispatch(inputUpdate(""));
  };

  const handleHitlAutoSend = (value, displayText = value) => {
    if (!value) return;

    handleSend(value, displayText);
  };

  const handleScroll = () => {
    if (messagesEndRef.current) {
      const currentScrollY = messagesEndRef.current.scrollTop;
      if (currentScrollY < lastScrollY.current) {
        setChatScroll("down");
      } else {
        setChatScroll("up");
      }
      lastScrollY.current = currentScrollY;
    }
  };

  const PREFILL_PROMPT_HCP =
    "Suggest some high growth potential HCPs to engage with";
  const PREFILL_PROMPT_RBD = "How is my region performing this quarter?";

  const lastPrefillRef = useRef({ id: null, prompt: null });

  useEffect(() => {
    const state = location.state || {};
    const prefill =
      state.prefillPrompt ||
      (state.fromHcpExplore ? PREFILL_PROMPT_HCP : null) ||
      (state.fromRbdExplore ? PREFILL_PROMPT_RBD : null);

    const prefillId = state.prefillId ?? prefill;

    if (!prefill) return;
    if (lastPrefillRef.current.id === prefillId) return;
    lastPrefillRef.current = { id: prefillId, prompt: prefill };

    (async () => {
      setActiveSessionId(""); // clear old session
      dispatch(resetMessages()); // clear UI messages
      dispatch(clearStreamData(false));
      dispatch(clearStreamingData(false));
      navigate(
        { pathname: location.pathname, search: location.search },
        { replace: true, state: {} },
      );

      const userSessionPayload = {
        userEmail,
        token: tokenSet,
        client,
        minRows,
        maxRows,
      };
      try {
        await dispatch(getUserSessions(userSessionPayload)).unwrap();
      } catch {}

      dispatch(inputUpdate(""));
      dispatch(resetMessages());
      dispatch(disableFormContol(false));
      dispatch(productsUpdate(""));
      dispatch(keyMessageUpdate(""));
      dispatch(newChatStateUpdate(true));

      if (isListening) stopAzureRecognition();
      await startNewSessionAndSend(prefill);
    })();
  }, [
    location.state,
    navigate,
    userEmail,
    tokenSet,
    client,
    minRows,
    maxRows,
    isListening,
    dispatch,
  ]);

  useEffect(() => {
    const container = messagesEndRef.current;
    if (container) container.addEventListener("scroll", handleScroll);
    return () => {
      if (container) container.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const srollDown = () => {
    messagesEndRefChild.current?.scrollIntoView({
      behavior: "smooth",
      block: "end",
      inline: "nearest",
    });
    setChatScroll("up");
  };

  const handleScrollUp = () => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
    setChatScroll("down");
  };

  const handleClickDialogOpen = () => setDialogOpen(true);
  const handleDialogClose = () => setDialogOpen(false);

  const handleLikeDialogClickOpen = useCallback((chat, user) => {
    setChatId(chat);
    setUserSessionId(user);
    setLikeDialogOpen(true);
  }, []);
  const handleLikeDialogClose = () => setLikeDialogOpen(false);

  const handleUnLikeDialogClickOpen = useCallback((chat, user) => {
    setChatId(chat);
    setUserSessionId(user);
    setUnLikeDialogOpen(true);
  }, []);
  const handleUnLikeDialogClose = () => setUnLikeDialogOpen(false);

  const onSubmit = () => {
    dispatch(inputUpdate(""));
    stopAzureRecognition();
    handleSend(input);
  };

  const onChangeTextField = (e) => dispatch(inputUpdate(e.target.value));

  const onKeyDownTextField = (e) => {
    if (e.key === "Enter") {
      dispatch(inputUpdate(""));
      onSubmit();
    }
  };

  const handleRenameDialogClose = () => setRenameDialogOpen(false);
  const handleRenamVal = (event) => setRenameval(event);
  const handleDeleteDialogClose = () => setDeleteDialogOpen(false);

  const dispatchDeleteProcess = () => {
    const deletepayload = {
      session: getSessionName.user_session_id,
    };
    const userSessionPayload = {
      userEmail: userEmail,
      token: tokenSet,
      client,
      minRows: 0,
      maxRows: maxRows,
    };
    dispatch(deleteUserSession(deletepayload));
    dispatch(getUserSessions(userSessionPayload));
    dispatch(resetMessages());
    setDeleteDialogOpen(false);
  };

  useEffect(() => {
    return () => {
      stopAzureRecognition();
    };
  }, []);

  const handleMicClick = () => {
    if (isListening) stopAzureRecognition();
    else startAzureRecognition();
  };

  const capitalizeWord = (s = "") =>
    s ? s.trim().charAt(0).toUpperCase() + s.trim().slice(1).toLowerCase() : "";

  const repEmail = userEmail;
  const cached = useSelector(
    (s) => s.callLog?.cacheByRepEmail?.[repEmail]?.data,
  );

  const handleLogCallClick = async () => {
    // If cached, open dialog immediately and do NOT call API
    if (cached) {
      setSelectedCallData(cached);
      setCallLogOpen(true);
      return;
    }

    // Otherwise call API (and it will get cached in Redux)
    setLogCallLoading(true);
    try {
      const resp = await dispatch(
        extractCallDetails({ repEmail, call_text: "" }),
      ).unwrap();
      setSelectedCallData(resp);
      setCallLogOpen(true);
    } catch (e) {
      dispatch(
        showSnackbar({
          message: typeof e === "string" ? e : "Failed to load rep information",
          severity: "error",
        }),
      );
      setCallLogOpen(false);
    } finally {
      setLogCallLoading(false);
    }
  };

  const handleCloseCallLog = () => {
    setCallLogOpen(false);
    setSelectedCallData(null);
  };

  const toolDisclaimerNotice = toolSynapse360Disclaimer ? (
    <div className="chat-tool-disclaimer">
      <InfoOutlinedIcon className="chat-tool-disclaimer-icon" aria-hidden="true" />
      <span>{toolSynapse360Disclaimer}</span>
    </div>
  ) : null;

  return (
    <>
      {isLoading && <Loader />}
      <Paper
        elevation={3}
        className={
          drawerOpen
            ? "paperWhenOpened drawer-paper"
            : "paperWhenClosed drawer-paper"
        }
        sx={{
          width: {
            sm: "100%",
            md: "calc(100% - 170px)",
          },
        }}
      >
        <SnackbarComponent />

        {messages?.length === 0 && (
          <Box
            mt={1}
            display="flex"
            alignItems="center"
            justifyContent="center"
            overflow="auto"
            className="text-holder-home"
          >
            <Typography className="enlarged-text" sx={{ color: "#323232" }}>
              {displayIdentityLoading ? (
                <>
                  Hello,{" "}
                  <UserNameSkeleton
                    width={90}
                    height={28}
                    sx={{ display: "inline-block", verticalAlign: "middle" }}
                  />
                </>
              ) : (
                <>Hello, {capitalizeWord(firstName)}</>
              )}
              <br />
              How can I help you today?
            </Typography>
          </Box>
        )}

        {messages?.length === 0 && (
          <>
            <Box
              sx={{ position: "relative", width: "100%" }}
              className="prompt-input-text-ai-text-holder"
            >
              <TextField
              className="input-chat-type"
              variant="outlined"
              placeholder="Enter your question here..."
              value={input}
              onChange={onChangeTextField}
              onKeyDown={onKeyDownTextField}
              fullWidth
              multiline
              minRows={1}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "8px",
                  border: "1px solid #CACACA",
                  alignItems: "flex-start",
                  padding: "8px 8px 64px",
                  border: "none",
                },
                "& .MuiInputBase-inputMultiline": {
                  padding: "14px 8px",
                },
              }}
            />

            {/* Bottom-left: Prompt Library + Log a Call (SalesRep only) */}

            <Box
              sx={{
                position: "absolute",
                left: 16,
                bottom: 12,
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <ChatToolsPlus onSelectTool={handleSelectTool} />

              <div
                className="prompt-holder"
                onClick={handleClickDialogOpen}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 4,
                  cursor: "pointer",
                  userSelect: "none",
                }}
              >
                <img src={GreenLibrary} alt="prompt-library" />
                Prompt Library
              </div>
              {isSalesRep && (
                <div
                  className="prompt-holder"
                  onClick={handleLogCallClick}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 4,
                    cursor: "pointer",
                    userSelect: "none",
                  }}
                >
                  {logCallLoading ? (
                    <>
                      <CircularProgress size={18} thickness={5} />
                      Loading...
                    </>
                  ) : (
                    <>
                      <img
                        src={CallLog}
                        alt="log-call"
                        width={16}
                        height={16}
                      />
                      Log a Call
                    </>
                  )}
                </div>
              )}
              <ActiveToolPill tool={activeTool} onClear={clearActiveTool} />
            </Box>

            <Box
              sx={{
                position: "absolute",
                right: 12,
                bottom: 12,
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <IconButton
                onClick={handleMicClick}
                className="mic-button-holder"
              >
                {isListening ? <MicIcon /> : <MicOffOutlinedIcon />}
              </IconButton>
              <ColorButton onClick={onSubmit} disabled={!input.trim()}>
                <img src={Send} alt="send" />
              </ColorButton>
            </Box>
            </Box>
            {toolDisclaimerNotice}
          </>
        )}

        <ChatsBox
          messages={messages}
          messagesEndRef={messagesEndRef}
          messagesEndRefChild={messagesEndRefChild}
          handleInputValue={handleInputValue}
          handleLikeDialogClickOpen={handleLikeDialogClickOpen}
          handleUnLikeDialogClickOpen={handleUnLikeDialogClickOpen}
          streamData={streamData}
          handleHitlAutoSend={handleHitlAutoSend}
        />

        {messages?.length > 0 && (
          <>
            <div className="prompt-input-text-ai-text-holder">
              <Box
                sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}
              >
                <ChatToolsPlus onSelectTool={handleSelectTool} />

                <div
                  className="prompt-holder prompt-holder-response"
                  onClick={handleClickDialogOpen}
                >
                  <img src={GreenLibrary} alt="prompt-library" /> Prompt Library
                </div>
                <ActiveToolPill
                  tool={activeTool}
                  onClear={clearActiveTool}
                  className="prompt-holder-response"
                />
              </Box>

              <TextField
                className="input-chat-type"
                variant="outlined"
                placeholder="Enter your question here..."
                value={input}
                onChange={onChangeTextField}
                fullWidth
                onKeyDown={onKeyDownTextField}
                InputProps={{
                  endAdornment: (
                    <InputAdornment
                      position="end"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <IconButton
                        onClick={handleMicClick}
                        className="mic-button-holder"
                      >
                        {isListening ? <MicIcon /> : <MicOffOutlinedIcon />}
                      </IconButton>
                      <ColorButton onClick={onSubmit} disabled={!input.trim()}>
                        <img src={Send} alt="send" />
                      </ColorButton>
                    </InputAdornment>
                  ),
                }}
              />
            </div>
            {toolDisclaimerNotice}
            <div className="ai-generated-text">
              The information is for guidance only and may not be complete or
              accurate. Use your professional judgment when relying on it.
              <br />
              Information from RepAssist should be used in compliance with{" "}
              <Link
                href="https://urldefense.com/v3/__https://unithercloud.sharepoint.com/sites/ComplianceResources__;!!Nyu6ZXf5!uC17SgyhieFPMeSbcVq45JCTB4_n0clZ2D556xS7Mj7fFR1Zyku727ZB9EYqIcKriuNChz-OsHPwQvfpnNc$"
                target="_blank"
                rel="noopener noreferrer"
              >
                UT policies
              </Link>
              .
            </div>
          </>
        )}

        {chatscroll === "up" && hasScrollbar && messages.length > 1 && (
          <IconButton className="chat-flow-scroll-up" onClick={handleScrollUp}>
            <KeyboardDoubleArrowUp />
          </IconButton>
        )}
        {chatscroll === "down" && hasScrollbar && messages.length > 1 && (
          <IconButton className="chat-flow-scroll-up" onClick={srollDown}>
            <KeyboardDoubleArrowDown />
          </IconButton>
        )}

        <PromptDialog
          dialogOpen={dialogOpen}
          handleDialogClose={handleDialogClose}
          userRole={role}
          activeToolId={activeToolId}
        />
        <LikeDialog
          open={likeDialogOpen}
          handleClose={handleLikeDialogClose}
          chatId={chatId}
          userSessionId={userSessionId}
        />
        <UnlikeDialog
          open={unLikeDialogOpen}
          handleClose={handleUnLikeDialogClose}
          chatId={chatId}
          userSessionId={userSessionId}
        />
        <RenameDialog
          open={renameDialogOpen}
          handleClose={handleRenameDialogClose}
          name={renameVal}
          userSessionId={getSessionName?.user_session_id}
          handleRenamVal={handleRenamVal}
        />
        <DeleteDialog
          open={deleteDialogOpen}
          handleClose={handleDeleteDialogClose}
          dispatchAction={dispatchDeleteProcess}
          name={getSessionName?.user_session_name}
        />
        <CallLogDialog
          open={callLogOpen}
          onClose={handleCloseCallLog}
          callData={selectedCallData}
        />
      </Paper>
    </>
  );
}

export default ChatFlow;
